import React, {useEffect, useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack} from "@mui/material";
import PlanService from "../../../../../../API/orders/optimization/organization/PlanService";
import TextFieldObject from "../../../../textfield/TextFieldObject";
import OrderService from "../../../../../../API/orders/orders/organization/OrderService";
import ButtonAdd from "../../../../button/ButtonAdd";
import ButtonExit from "../../../../button/ButtonExit";

const ModalSetPlan = ({
                          open,
                          handleClose,
                          selectedIds,
                          data,
                          setData,
                          handleModalAlert,
                          setRowSelection,
                          handleSearchQuery,
                          globalFilter,
                          setLists
                      }) => {

        const [planList, setPlanList] = useState(null);
        const [planId, setPlanId] = useState(null);
        const [loading, setLoading] = useState(false)

        useEffect(() => {

            PlanService.getAllNotArchive().then(function (response) {
                let data = response.data;
                setPlanList(data);
                setPlanId(data[0]?.id)
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }, []);

        const handleSubmit = () => {
            setLoading(true)
            OrderService.setPlanByIds(selectedIds, planId,)
                .then(function () {
                    const newData = data.map(item => {
                        if (selectedIds.includes(item.id)) {
                            const selectedPlan = planList.find(plan => plan.id.toString() === planId.toString());
                            return {
                                ...item,
                                plan: selectedPlan
                            };
                        } else {
                            return item;
                        }
                    });
                    setData(newData);
                    handleSearchQuery(globalFilter, newData)
                    setLists(newData)
                    handleClose();
                    setRowSelection([])
                    handleModalAlert("Добавлено", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
                .finally(() => setLoading(false))
        }

        return (
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle textAlign="center">{"Добавить в план"}</DialogTitle>
                <DialogContent>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <Stack
                            sx={{
                                width: '100%',
                                minWidth: {xs: '300px', sm: '360px', md: '400px'},
                                gap: '1.5rem',
                            }}
                        >
                            {planList && <TextFieldObject
                                label="План"
                                field={'plan'}
                                value={planId}
                                setId={setPlanId}
                                entityList={planList}
                            />}
                        </Stack>
                    </form>
                </DialogContent>
                <DialogActions sx={{p: '1.25rem'}}>
                    <ButtonExit text={"Выйти"} onClick={handleClose}/>
                    <ButtonAdd loading={loading} text={"Обновить"} disabled={!planId} onClick={handleSubmit}/>
                </DialogActions>
            </Dialog>
        );
    }
;

export default ModalSetPlan;